<template>
  <div>
    <card card-body-classes="table-full-width px-4">
      <div slot="header">
        <h4 class="card-title f-20-mobile">Inventário até o dia {{data_fim_cabecalho}}</h4>
      </div>

      <div class="row mb-3">
        <div class="col-md-6 col-12">
          <input type="date" class="form-control d-inline mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
          <n-button type="primary" class="btn btn-round d-inline btn-wd btn-info mx-auto-mobile mb-2-mobile" v-on:click.native="filtrar" style="margin-left: 20px; height: 35px">Filtrar</n-button>
        </div>
          
        <div class="col-md-6 col-12 text-right">
          <input type="checkbox" v-model="custo" @change="recalculaTotal"> Usar valor de custo |
          <input type="checkbox" v-model="positivos" @change="recalculaTotal"> Exibir Somente positivos
        </div>

        <div class="col-12">
          <input type="button" @click="exportaPDF" value="Gerar PDF" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary">
        </div>

        <div class="col-6">
          <span class="d-inline" style="font-size: 22px; margin-right: 10px">Livro: </span>
          <input class="d-inline form-control" style="max-width: 150px;" type="text" id="livro" v-model="livro">
        </div>

        <div class="col-6 text-right">
          <input class="form-control pull-right hidden-mobile" type="text" id="myInput" @keyup="pesquisar" placeholder="Buscar pelo nome, descrição.." style="max-width: 300px;">
        </div>
      </div>    

      <table class="display responsive nowrap table table-hover table-striped" id="myTable">
        <thead>
          <tr>
            <th>Código</th>
            <th>Código PDV</th>
            <th>Descrição</th>
            <th>NCM</th>
            <th class="text-center">Unidade</th>
            <th class="text-center">Quantidade</th>
            <th class="text-center">Vlr. Unitário</th>
            <th class="text-center">Vlr. Total</th>
            <th class="text-right">Editar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(produto,index) of produtos" v-if="produto.quantidade >= 0 || !positivos">
            <td class="">{{ produto.codigo }}</td>
            <td class="">{{ produto.referencia }}</td>
            <td class="">{{ produto.descricao }}</td>
            <td class="">{{ produto.ncm_sh }}</td>
            <td class="text-center">{{ produto.unidade }}</td>
            <td class="text-center">{{ produto.quantidade.toFixed(3).replace(".",",") }}</td>
            <td class="text-center">{{ produto.valor_unitario | currencyBrl(false) }}</td>
            <td class="text-center">{{ produto.total | currencyBrl(false) }}</td>
            <td class="text-right">
              <a title="Editar quantidade" @click="editavalor(produto.quantidade,index)" class="btn btn-primary btn-sm mr-1" style="padding-left: 10px; padding-right: 10px;">
                <i class="fa fa-pencil" style="font-size: 12px"></i>
              </a>

              <a title="Editar valor unitário" @click="editaValorUn(produto.valor_unitario,index)" class="btn btn-info btn-primary btn-sm" style="padding-left: 10px; padding-right: 10px" >
                <i class="fa fa-money" style="font-size: 12px"></i>
              </a>
            </td>
          </tr>
          <tr v-if="!produtos || !produtos.length"> 
            <td class="text-center" colspan="9">Nenhum resultado encontrado</td>
          </tr>
        </tbody>
      </table>

      <!--TABEAL PRA EXPORTAR COM CABEÇALHO COM DADOS DA EMPRESA-->
      <table class="" width=100% border=1 align='center' id="tabela_exporta" style="font-size: 10px;display:none">
        <thead style="background-color:white;color:black;">
            <tr style="font-size: 16px;">
                <th  align="center" style="border-bottom: 2px solid;" colspan="8">REGISTRO DE INVENTÁRIO</th>
            </tr>
            <tr style="font-size: 16px;">
                <th  align="left" colspan="8">Razão Social: {{razao_social}}</th>
            </tr>
            <tr style="font-size: 16px;">
                <th  align="left" colspan="8">CNPJ: {{cnpj}}</th>
            </tr>
            <tr style="font-size: 16px;">
                <th  align="left" colspan="3">Insc. Estadual: {{inscricao}}</th>
                <th align="right" colspan="5">Estoque Existente em: {{data_fim_cabecalho}}</th>
            </tr>
            <tr style="border-top:2px solid" class="final">
              <th  align="left" colspan="3">LIVRO: {{livro}}</th>
              <th colspan="2">FOLHA: <span id="total_paginas"></span></th>
              <th align="right" colspan="3">Total: R$ {{total | currencyBrl(false)}}</th>  
            </tr>
            <tr>
                <th colspan="7"></th>
            </tr>
            <tr style="margin-top:20px">
                <th style="font-size: 12px;">Código</th>
                <th style="font-size: 12px;">Código PDV</th>
                <th>Descrição</th>
                <th>NCM</th>
                <th>Unidade</th>
                <th>Quantidade</th>
                <th>Vlr. Unitário</th>
                <th>Vlr. Total</th>
            </tr>
            
        </thead>
        <tbody>
            <tr v-for="(produto_exportar,index) of produtos" v-if="produto_exportar.quantidade >= 0 || !positivos">
              <td class="">{{ produto_exportar.codigo }}</td>
              <td class="">{{ produto_exportar.referencia }}</td>
              <td class="">{{ produto_exportar.descricao }}</td>
              <td class="">{{ produto_exportar.ncm_sh }}</td>
              <td class="text-center">{{ produto_exportar.unidade }}</td>
              <td class="text-center">{{ produto_exportar.quantidade.toFixed(3).replace(".",",") }}</td>
              <td class="text-center">{{ produto_exportar.valor_unitario | currencyBrl(false) }}</td>
              <td class="text-center">{{ produto_exportar.total | currencyBrl(false) }}</td>
            </tr> 
        </tbody>
      </table>  
      <!--FIM DA TABELA DE EXPORTACAO-->
    </card>
  </div>
</template>

<!-- 
  N. Pedido
  Dt. Emissão
  Status
  Protocolo
  Modelo
  Série
  N. Nota -->
<script>
  import axios from 'axios'
  import {
    Card
  } from 'src/components'
import moment from 'moment'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import FiscalService from '@/services/FiscalService.js'
import VendaService from '@/services/VendaService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        token: null,
        linkPDF:'',
        positivos: true,
        livro:1,
        custo: false,
        produtos: [],
        cnpj:null,
        total:0,
        razao_social:'',
        inscricao:null,
      }
    },
    methods:{
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.loadInventario();
      },
      recalculaTotal(){
        this.total = 0;
        this.produtos.forEach(produto=>{
          if((this.positivos && produto.total >= 0) || !this.positivos){
            this.total += produto.total;
            console.log(this.total);
          }
        });
      },
      loadInventario() {
        let params = `?data_fim=${this.data_fim}&positivos=`+this.positivos;
        let loader = this.$loading.show();

        if(this.custo) {
          params += "&custo=true"
        }

        FiscalService.loadInventario(params).then(res => {
          this.produtos = res.data.produtos;
          this.cnpj = res.data.instalacao.cnpj;
          this.razao_social = res.data.instalacao.razao_social;
          this.inscricao = res.data.instalacao.inscricao;
          this.total = 0;
          this.produtos.forEach(produto=>{
            if((this.positivos && produto.total >= 0) || !this.positivos){
              this.total += produto.total;
              console.log(this.total);
            }
          });
          loader.hide();
          this.reloadLinkPDF();
        }).catch(err => {
          loader.hide();
        })
      },
      reloadLinkPDF(){
        let stores = JSON.parse(localStorage.getItem('stores'));
        let loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
        let url = process.env.VUE_APP_API_URL + 'relatorioInventario';
        let params = "?token=" + localStorage.getItem("token") + "&" + "data_fim=" +this.data_fim;

        this.linkPDF = url + params;
      },
      pesquisar() {
        // Declare variables
        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        table = document.getElementById("myTable");
        tr = table.getElementsByTagName("tr");
        
        // Loop through all table rows, and hide those who don't match the search query
        for (i = 0; i < tr.length; i++) {
          td = tr[i].getElementsByTagName("td")[1];
          if (td) {
            txtValue = td.textContent || td.innerText;
            console.log(txtValue);
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              tr[i].style.display = "";
            } else {
              tr[i].style.display = "none";
            }
          }
        }
      },
      getMaxLengthProdutos() {
        let length = 1;

        if(this.produtos) {
          for(let produto of this.produtos) {
            if(produto.descricao && produto.descricao.length > length) {
              length = produto.descricao.length
            }
          }
        }

        return length
      },
      exportaPDF(){
        this.$forceUpdate();
        let length_multiplicador = this.getMaxLengthProdutos()
        console.log(length_multiplicador)

        if(length_multiplicador < 35) {
          length_multiplicador = 35
        }

        var doc = new jsPDF();
        doc.setFontSize(12);
        
        let elem = document.getElementById("tabela_exporta");

        doc.autoTable({
          html:elem,
          styles: {
            lineColor: [222, 226, 230],
            lineWidth: 0.55,
            fontSize:8,
          },
          tableLineColor: [0, 0, 0],
          tableLineWidth: 0.10,
          headStyles: {
            fillColor: [255, 255, 255],
            fontSize: 8,
            textColor:[0,0,0]
          },
          didDrawCell: data => {
            if(data && data.cell && data.cell.text && data.cell.text.length) {
              if(data.cell.text[0] == 'FOLHA: ') {
                doc.text(data.cell.x + 14 , 45.3, "" + (doc.internal.getCurrentPageInfo().pageNumber + 1));
              }
            }
          }
        });
        doc.setFont("Roboto");
        doc.setFontType("bold");
        doc.setFontSize(10);  
        doc.setTextColor(0,0,0);

        var pageCount = doc.internal.getNumberOfPages();

        doc.setFontSize(9);
        doc.save('inventário.pdf');
      },
      editavalor(quantidade,index) {
        this.$swal({
          title: '',
          input:'text',
          inputValue: quantidade,
          title: "Editar quantidade"
        }).then(nova_quantidade => {
          if(parseFloat(nova_quantidade.value.replace(",",".")) || parseFloat(nova_quantidade.value.replace(",",".")) === 0){
            this.total = 0;
            this.produtos[index].quantidade = parseFloat(nova_quantidade.value.replace(",","."))
            this.produtos[index].total = this.produtos[index].quantidade * this.produtos[index].valor_unitario;
            this.produtos.forEach(produto=>{
              this.total += produto.total;
              console.log(this.total);
            });
          }
        });
      },
      editaValorUn(valor,index){
        this.$swal({
          title: '',
          input:'text',
          inputValue: valor,
          title: "Editar valor unitário"
        }).then(novo_valor => {
          if(parseFloat(novo_valor.value.replace(",","."))){
            this.total = 0;
            this.produtos[index].valor_unitario = parseFloat(novo_valor.value.replace(",","."))
            this.produtos[index].total = this.produtos[index].valor_unitario * this.produtos[index].quantidade;
            this.produtos.forEach(produto=>{
              this.total += produto.total;
              console.log(this.total);
            });
          }
        });
      }
    },
    mounted() {
      this.token = localStorage.getItem('token');
      // this.loadInventario()
    }
}
</script>

<style type="text/css">
</style>